import React from "react";

const Portfolio = () => {
  return (
    <section className="portfolio">
      <div className="portfolio-content">
        <h2>Nos Récentes Réalisations</h2>
        <p>
          Découvrez nos projets d’habillage de façades et panneaux publicitaires.
        </p>
        <a href="/services"><button className="btn-primary">Voir Notre Services</button></a>
      </div>
    </section>
  );
};

export default Portfolio;